import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import { LoadingContext, ModeReglementContext } from '@/contexts';
import ModesReglementListeTableRow from './ModesReglementListeTableRow';

const ModesReglementListe = () => {
  const { modesReglements, getModesReglements } = React.useContext(ModeReglementContext);
  const { modesReglementsLoadings } = React.useContext(LoadingContext);

  const renderRow = (item, __, rowProps) => (
    <ModesReglementListeTableRow item={item} rowProps={rowProps} />
  );

  React.useEffect(() => {
    getModesReglements();
  }, [getModesReglements]);

  return (
    <div style={{ height: '100%' }}>
      <ListeTable
        count={_.size(modesReglements)}
        items={modesReglements}
        loading={modesReglementsLoadings.modesReglements}
      >
        <ListeTable.Header>
          <ListeTable.Column name="libelle" width={4}>
            Mode de règlement
          </ListeTable.Column>
          <ListeTable.Column name="code">Code</ListeTable.Column>
        </ListeTable.Header>
        {renderRow as unknown as React.ReactNode}
      </ListeTable>
    </div>
  );
};

export default ModesReglementListe;
